/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignLaunchLaunchPathParams,
	CampaignLaunchLaunchRequest,
	CampaignLaunchLaunchResponse,
} from '../types/CampaignLaunchLaunch'

/**
 * POST /campaigns/:campaign/launch
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignLaunchController.php CampaignLaunchController::launch
 */
export async function campaignLaunchLaunch(
	campaign: CampaignLaunchLaunchPathParams['campaign'],
	data: CampaignLaunchLaunchRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignLaunchLaunchResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/launch`, data, config)
}
